import { parseData } from '@devhacker/shared/utils/parseData';
import { cacheApiResponseWithRedis } from '@devhacker/shared/utils/cacheApiResponseWithRedis';
import { MENUS_TECH_NAMES } from '~/constants';
import type { IMenu, TMenuDomain } from '~/types/store/menus';
import { menusSchema } from '~/schemas/wordpressSchema';
import { wrapPiniaStore } from '@devhacker/shared/utils/wrapPiniaStore';
import { defineStore } from 'pinia';

export const useMenusStore = wrapPiniaStore(
  defineStore('menus', {
    state: (): Record<TMenuDomain, IMenu> => ({
      'bh-kiss-first-level': {
        domain: 'bh-kiss-first-level',
        items: [],
        name: '',
      },
      'bh-kiss-second-level': {
        domain: 'bh-kiss-first-level',
        items: [],
        name: '',
      },
      'bh-kiss-info': {
        domain: 'bh-kiss-first-level',
        items: [],
        name: '',
      },
      'bh-kiss-topics': {
        domain: 'bh-kiss-first-level',
        items: [],
        name: '',
      },
      'bh-kiss-socials': {
        domain: 'bh-kiss-first-level',
        items: [],
        name: '',
      },
      'bh-kiss-footer-info': {
        domain: 'bh-kiss-first-level',
        items: [],
        name: '',
      },
      'bh-kiss-footer-subs': {
        domain: 'bh-kiss-first-level',
        items: [],
        name: '',
      },
      'bh-kiss-footer-rules': {
        domain: 'bh-kiss-first-level',
        items: [],
        name: '',
      },
    }),

    getters: {
      mainArrowMenu: (state) => state['bh-kiss-first-level'],
      secondArrowMenu: (state) => state['bh-kiss-second-level'],
      burgerInfo: (state) => state['bh-kiss-info'],
      burgerRubrics: (state) => state['bh-kiss-topics'],
      burgerSocials: (state) => state['bh-kiss-socials'],
      footerInfo: (state) => state['bh-kiss-footer-info'],
      footerSubs: (state) => state['bh-kiss-footer-subs'],
      footerRules: (state) => state['bh-kiss-footer-rules'],

      burgerItems(state) {
        const { burgerSocials, burgerInfo, burgerRubrics } = MENUS_TECH_NAMES;
        return [state[burgerInfo], state[burgerRubrics], state[burgerSocials]];
      },
      footerItems(state) {
        const { footerInfo, footerRules, footerSubs } = MENUS_TECH_NAMES;
        return [state[footerInfo], state[footerSubs], state[footerRules]];
      },
    },

    actions: {
      async fetchMenus() {
        const { $api, $redisClient } = useNuxtApp();

        const { data } = await cacheApiResponseWithRedis(
          'FETCH_MENUS',
          $api.wordPress.fetchMenus,
          $redisClient,
          60 * 60, // 1 hour
        );

        const parsedResponse = parseData(data, menusSchema) as {
          items: IMenu[];
        };

        for (const item of parsedResponse.items) {
          this[item.domain] = item;
        }
      },
    },
  }),
);
